import { useState } from 'react';
import axios from 'axios';
import { VideoCameraIcon } from '@heroicons/react/20/solid';
import { useGcal } from '@geerd-nx/gcal';
import { Modal } from './..';
import DotLoader from 'react-spinners/DotLoader';
import { Video } from '../.';
export function VideoPreview({
  uid,
  ASSETS_API,
  logo_white,
}: {
  uid: string;
  ASSETS_API: string;
  logo_white?: string;
}) {
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const { getSession } = useGcal();
  const asset_service = axios.create({ baseURL: `${ASSETS_API}/api/video` });
  const getDowbloadUrl = async () => {
    if (uid.startsWith('cloudflare://')) {
      // get signed post request
      setLoading(true);
      const session = await getSession();
      const token = session.getAccessToken().getJwtToken();
      await asset_service
        .post(
          '/download-url',
          {
            uid: `${uid.replace('cloudflare://', '')}`,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        )
        .then((res: any) => {
          setUrl(res.data.videoUrl);
          setLoading(!!url);
          return res.data.videoUrl;
        })
        .catch((err: any) => {
          console.log(err.message);
        });
    } else {
      setUrl(uid);
    }
  };

  return (
    <>
      <Modal
        className="sm:p-0 sm:max-w-lg"
        show={!!url}
        onClose={function () {
          setUrl('');
        }}
      >
        <Video url={url} logo_white={logo_white} />
      </Modal>
      <button
        type="button"
        title="Play Video"
        onClick={getDowbloadUrl}
        className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
      >
        <DotLoader
          color={'#fff'}
          loading={loading}
          size={15}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
        {!loading && <VideoCameraIcon className="h-4 w-4" aria-hidden="true" />}{' '}
      </button>
    </>
  );
}
